import { render } from "./PageDashboard.vue?vue&type=template&id=bf1a106c&scoped=true"
import script from "./PageDashboard.vue?vue&type=script&lang=js"
export * from "./PageDashboard.vue?vue&type=script&lang=js"

import "./PageDashboard.vue?vue&type=style&index=0&id=bf1a106c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf1a106c"]])

export default __exports__